var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.827 3.552A5.404 5.404 0 005.969.568a5.27 5.27 0 00-2.428.585c-1.29.645-2.234 1.769-2.699 3.163-.45 1.38-.345 2.879.285 4.122.705 1.395 3.913 5.263 4.273 5.698l.57.674.554-.69c.15-.18 3.508-4.272 4.273-5.666.84-1.5.84-3.283.03-4.902z",
    fill: "#58B847"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "location_icon_2_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h12v15.378H0V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#location_icon_2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97 1.137c-.76 0-1.49.175-2.17.521-1.14.571-1.997 1.579-2.417 2.838-.402 1.23-.31 2.575.252 3.686.62 1.226 3.364 4.577 4.19 5.574l.135.16.123-.152c.563-.677 3.536-4.344 4.217-5.584.741-1.325.748-2.918.02-4.374a4.842 4.842 0 00-4.35-2.67zm0 14.241a.568.568 0 01-.434-.202l-.57-.674c-1.1-1.329-3.69-4.512-4.345-5.807C-.076 7.318-.192 5.658.303 4.14.82 2.588 1.88 1.348 3.287.644A5.867 5.867 0 015.97 0a5.974 5.974 0 015.366 3.297c.9 1.799.885 3.78-.042 5.434-.808 1.474-4.297 5.712-4.33 5.753l-.551.683a.571.571 0 01-.436.211H5.97z",
    fill: "#58B847"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.104 5.584a2.104 2.104 0 11-4.208 0 2.104 2.104 0 014.208 0z",
    fill: "#fff"
  })));
}
export default SvgLocationIcon2;